import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, withModifiers as _withModifiers, createElementBlock as _createElementBlock, Fragment as _Fragment, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-d818e372"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "form-align"
}
const _hoisted_2 = { "data-cy": "heading" }
const _hoisted_3 = {
  class: "small",
  "data-cy": "instruction.sub"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_5 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))
const _hoisted_6 = { "data-cy": "confirmation-title" }
const _hoisted_7 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("br", null, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_InlineError = _resolveComponent("InlineError")!
  const _component_ValidatedMessage = _resolveComponent("ValidatedMessage")!
  const _component_BaseInputText = _resolveComponent("BaseInputText")!
  const _component_BaseButton = _resolveComponent("BaseButton")!
  const _component_MHForm = _resolveComponent("MHForm")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_BaseWrapper = _resolveComponent("BaseWrapper")!

  return (_openBlock(), _createBlock(_component_BaseWrapper, {
    verticalCenter: true,
    size: "xs"
  }, {
    default: _withCtx(() => [
      (_ctx.showForm)
        ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
            _createElementVNode("h3", _hoisted_2, _toDisplayString(_ctx.isExpiredPasswordUserFlow ? _ctx.$t('passwordExpiredForm.heading') : _ctx.$t('passwordResetForm.heading')), 1),
            (_ctx.showCurrentPasswordError)
              ? (_openBlock(), _createBlock(_component_InlineError, {
                  key: 0,
                  class: "password-alert-wrapper",
                  "data-cy": "passwordWrong-inlineError",
                  message: _ctx.$t('incorrectCurrentPasswordDescription')
                }, null, 8, ["message"]))
              : _createCommentVNode("", true),
            _createElementVNode("p", _hoisted_3, _toDisplayString(_ctx.$t('instructions.sub')), 1),
            _createVNode(_component_MHForm, {
              ref: "form",
              onSubmit: _cache[3] || (_cache[3] = _withModifiers(() => {}, ["prevent"]))
            }, {
              default: _withCtx((formProps) => [
                _createVNode(_component_ValidatedMessage, {
                  "data-cy": "lowerCaseRule",
                  validated: _ctx.newPasswordValid,
                  message: _ctx.$t('instructions.lowerCaseRule')
                }, null, 8, ["validated", "message"]),
                _createVNode(_component_ValidatedMessage, {
                  "data-cy": "capitalRule",
                  validated: _ctx.newPasswordValid,
                  message: _ctx.$t('instructions.capitalRule')
                }, null, 8, ["validated", "message"]),
                _createVNode(_component_ValidatedMessage, {
                  "data-cy": "numberRule",
                  validated: _ctx.newPasswordValid,
                  message: _ctx.$t('instructions.numberRule')
                }, null, 8, ["validated", "message"]),
                _createVNode(_component_ValidatedMessage, {
                  "data-cy": "sizeRule",
                  validated: _ctx.newPasswordValid,
                  message: _ctx.$t('instructions.sizeRule')
                }, null, 8, ["validated", "message"]),
                _hoisted_4,
                (_ctx.isExpiredPasswordUserFlow)
                  ? (_openBlock(), _createBlock(_component_BaseInputText, {
                      key: 0,
                      "data-cy": "currentPassword",
                      validationRules: "required",
                      inputType: "password",
                      inputName: "currentPassword",
                      labelLocation: "top",
                      labelText: _ctx.$t('passwordResetForm.currentPassword.label'),
                      inputModel: _ctx.currentPassword,
                      getAllErrors: true,
                      "onUpdate:inputModel": _cache[0] || (_cache[0] = ($event: any) => (_ctx.currentPassword = $event))
                    }, null, 8, ["labelText", "inputModel"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_BaseInputText, {
                  "data-cy": "newPassword",
                  validationRules: "required|min:8|upperCase|lowerCase|oneNumber",
                  inputType: "password",
                  inputName: "newPassword",
                  labelLocation: "top",
                  labelText: _ctx.$t('passwordResetForm.newPassword.label'),
                  inputModel: _ctx.newPassword,
                  displayValidationError: false,
                  getAllErrors: true,
                  "onUpdate:inputModel": _cache[1] || (_cache[1] = ($event: any) => (_ctx.newPassword = $event)),
                  onValidityUpdate: _ctx.setNewPasswordValid
                }, null, 8, ["labelText", "inputModel", "onValidityUpdate"]),
                (formProps.errors.newPassword)
                  ? (_openBlock(), _createBlock(_component_InlineError, {
                      key: 1,
                      "data-cy": "password-inlineError",
                      message: formProps.errors.newPassword
                    }, null, 8, ["message"]))
                  : _createCommentVNode("", true),
                (_ctx.prevPassError)
                  ? (_openBlock(), _createBlock(_component_InlineError, {
                      key: 2,
                      "data-cy": "prev-pass-inlineError",
                      message: _ctx.$t('passwordResetForm.matchesPrevPasswordError')
                    }, null, 8, ["message"]))
                  : _createCommentVNode("", true),
                _createVNode(_component_BaseInputText, {
                  "data-cy": "confirmPassword",
                  validationRules: "required",
                  inputName: "confirmPassword",
                  inputType: "password",
                  labelLocation: "top",
                  labelText: _ctx.$t('passwordResetForm.confirmPassword.label'),
                  inputModel: _ctx.confirmPassword,
                  displayValidationError: false,
                  getAllErrors: true,
                  "onUpdate:inputModel": _cache[2] || (_cache[2] = ($event: any) => (_ctx.confirmPassword = $event)),
                  onValidityUpdate: _ctx.setConfirmPasswordValid
                }, null, 8, ["labelText", "inputModel", "onValidityUpdate"]),
                (formProps.meta.touched && !_ctx.newAndConfirmMatch)
                  ? (_openBlock(), _createBlock(_component_InlineError, {
                      key: 3,
                      "data-cy": "inlineError",
                      message: _ctx.$t('passwordResetForm.passwordMatchError')
                    }, null, 8, ["message"]))
                  : _createCommentVNode("", true),
                _hoisted_5,
                _createVNode(_component_BaseButton, {
                  "data-cy": "resetBtn",
                  disabled: !formProps.meta.valid,
                  onClick: _ctx.doResetPassword
                }, {
                  default: _withCtx(() => [
                    _createTextVNode(_toDisplayString(_ctx.isExpiredPasswordUserFlow ? _ctx.$t('passwordExpiredForm.updateBtn') : _ctx.$t('passwordResetForm.resetBtn')), 1)
                  ]),
                  _: 2
                }, 1032, ["disabled", "onClick"])
              ]),
              _: 1
            }, 512)
          ]))
        : (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
            _createElementVNode("h3", _hoisted_6, _toDisplayString(_ctx.$t('confirmationTitle')), 1),
            _createElementVNode("p", null, _toDisplayString(_ctx.$t('confirmationText')), 1),
            _hoisted_7,
            _createVNode(_component_router_link, {
              class: "btn-ghost",
              to: "/login",
              "data-cy": "backToLoginBtn"
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_ctx.$t('backToLoginBtn')), 1)
              ]),
              _: 1
            })
          ], 64))
    ]),
    _: 1
  }))
}